import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import { getImageJSON } from '../../constants/jsonImages';

export default function Animation(props) {
  const defaultOptions = {
    loop: props.loop || false,
    autoplay: props.autoPlay || false,
    animationData: getImageJSON(props.type),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className={props.className}>
      <Lottie
        {...props}
        isStopped={!props.play}
        options={defaultOptions}
        height={props.height}
        width={props.width}
      />
    </div>
  );
}

Animation.propTypes = {
  play: PropTypes.bool,
  type: PropTypes.string,
  loop: PropTypes.bool,
  autoPlay: PropTypes.bool,
  onClick: PropTypes.func,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
};
